import React, { useEffect } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { get, isNil } from 'lodash';

import { fetchSensorTypes } from '../../../actions/sensorTypeActions';
import AutoComplete from '../../../components/FormFields/Autocomplete';

import classes from './selects.module.css';

const SensorTypeSelect = ({
    errors,
    fetchSensorTypes,
    onBlur,
    onPatch,
    touched,
    values,
    ...props
}) => {
    const dispatch = useDispatch();
    const sensorTypes = useSelector(
        ({ sensorTypes }) => sensorTypes
    );

    useEffect(() => {
        if (sensorTypes.loading || get(sensorTypes, 'data[0].items', []).length) {
            return;
        }
        dispatch(fetchSensorTypes());
    }, []);

    function handleChange(event) {
        const { value } = event.target;

        if (isNil(value)) return;

        onPatch({
            label:          value.name,
            sensorTypeId:   value.id,
            sensorTypeName: value.name
        });
    }

    if (!sensorTypes.data.length) return null;

    return (
        <AutoComplete
            className={classes.autoComplete}
            grouped
            label="Sensor Type"
            placeholder="Sensor Type"
            name="sensorTypeId"
            id="sensorTypeId"
            onBlur={onBlur}
            onChange={handleChange}
            error={Boolean(sensorTypes.error)}
            options={sensorTypes.data}
            value={values}
        />
    );
};

SensorTypeSelect.defaultProps = {
    errors:  {},
    fetchSensorTypes,
    onBlur:  () => {},
    onPatch: () => {},
    touched: {},
    values:  {}
};

SensorTypeSelect.propTypes = {
    errors: shape({
        sensorTypeId: string
    }),
    fetchSensorTypes: func,
    onBlur:           func,
    onPatch:          func,
    touched:          shape({
        sensorTypeId: bool
    }),
    values: shape({
        sensorTypeId: string
    })
};

export default SensorTypeSelect;
